import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy: React.FC = () => {
  return (
    <div className="prose max-w-3xl mx-auto">
      <h1>Cookie & Consent Policy</h1>
      <p>
        We use cookies and similar technologies to provide, secure, and improve our services.
        Some cookies are essential, while others help us analyze usage and personalize content.
      </p>

      <h2>Types of Cookies</h2>
      <ul>
        <li>Strictly necessary: Required for core functionality (cannot be disabled)</li>
        <li>Analytics: Help us understand how the service is used</li>
        <li>Marketing: Used to deliver and measure ads (if applicable)</li>
      </ul>

      <h2>Managing Consent</h2>
      <p>
        You can manage your cookie preferences at any time using the consent banner or your
        browser settings. For data access, rectification, or deletion, submit a
        <Link to="/privacy/dsr" className="ml-2 text-indigo-600 underline">Data Subject Request</Link>.
      </p>

      <h2>Related Policies</h2>
      <ul>
        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
        <li><Link to="/privacy/retention-policy">Data Retention Policy</Link></li>
      </ul>

      <p className="text-sm text-gray-500">Last updated: 2025-08-10</p>
    </div>
  );
};

export default CookiePolicy;
